import { ComponentRef, ViewContainerRef } from "@angular/core";
import { ChangeRecoveryNumberComponent } from "./change-recovery-number.component";

class ChangeRecoveryNumberFormSession implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    viewContainerRef: ViewContainerRef;
    changeRecoveryNumberComponentRef: ComponentRef<ChangeRecoveryNumberComponent>;

    constructor(formId: string, payload: object) {
        this.formId = formId;
        this.payload = payload;
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        this.viewContainerRef.clear();
        this.changeRecoveryNumberComponentRef = this.viewContainerRef.createComponent(ChangeRecoveryNumberComponent);
        this.changeRecoveryNumberComponentRef.instance.onSubmitNewRecoveryNumber = this.onSubmitReoveryNumber.bind(this);
        this.changeRecoveryNumberComponentRef.instance.onSkipRecoveryNumberClick = this.onSkipRecoveryNumberClick.bind(this);

        const journeyPayload = this.payload as JourneyPayload;

        const action = journeyPayload.actions[0] as ActionsInPayload;

        this.changeRecoveryNumberComponentRef.instance.flowFromPayload = 'changeUsername';

        return new Promise((resolve, reject) => {
          this.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
              this.submitBlock = null;
            } catch (e) {
              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {
      }

      onError(payload: object): void {
        const userEmail = this.clientContext['cookieService'].get('username');
        if (payload){
          const errorCode = payload['code'];
          setTimeout(() => this.changeRecoveryNumberComponentRef.instance.setErrorCode(errorCode), 100);
        }
      }

      private onSubmitReoveryNumber(payload: object) {
        this.clientContext['nextStep'] = 'changeRecoveryNumberFlow';
        const data = payload;
        this.submitBlock(data);
      }

      private onSkipRecoveryNumberClick(){
        const userEmail = this.clientContext['cookieService'].get('username');
        const url = this.clientContext['redirect_uri'];
        const state = this.clientContext['state'];
        const errorCode  = 'ctnupdateskip';
        let appendChar = '?';
        if (url.includes('?'))
        {
           appendChar = '&';
        }
        window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=ctnupdateskip' 
        + '&lang=' + this.clientContext['cookieService'].get('lang')
        + '&state=' + state;
      }

}

interface JourneyPayload {
    actions: ActionsInPayload[];
    stat: string;
    code: string;
    flow: string;
  }

interface ActionsInPayload {
    [key: string]: any;
  }

export default ChangeRecoveryNumberFormSession;
